import { CommingSoon } from "./components/CommonComponents/ComingSoon";
import Dashboard from "./components/Dashboard/Dashboard";
import CityMaster from "./components/Master/CityMaster";
import VehicleModel from "./components/Master/VehicleModel";
import VehicleType from "./components/Master/VehicleType";
import PickupRequest from "./components/Operation/PickupRequest";
import ShipmentReport from "./components/Report/ShipmentReport";
import LabelPrint from "./components/Tracking/LabelPrint";
import Tracking from "./components/Tracking/Tracking";
import ChangePassword from "./components/UserSection/ChangePassword";
import GroupMasterForm from "./components/UserSection/GroupMaster";
import GroupMenuAccess from "./components/UserSection/GroupMenuAccess";
import ResetPassword from "./components/UserSection/ResetPassword";
import UserLogReport from "./components/UserSection/UserLogReport";
import UserMaster from "./components/UserSection/UserMaster";
export const routes = [
    {
        path: '*',
        component: CommingSoon
    },
    {
        path: 'Dashboard',
        component: Dashboard
    },
    {
        path: 'UserMaster',
        component: UserMaster
    },
    {
        path: 'ChangePassword',
        component: ChangePassword
    },
    {
        path: 'ResetPassword',
        component: ResetPassword
    },
    {
        path: 'GroupMaster',
        component: GroupMasterForm
    },
    {
        path: 'GroupMenuAccess',
        component: GroupMenuAccess
    },
    {
        path: 'CityMaster',
        component: CityMaster
    },
   
    {
        path: 'VehicleType',
        component: VehicleType
    },
   
    {
        path: 'UserLogReport',
        component: UserLogReport
    },
   
    {
        path: 'VehicleModel',
        component: VehicleModel
    },
    {
        path: 'PickupRequest',
        component: PickupRequest
    },
    {
        path: 'ShipmentReport',
        component: ShipmentReport
    },
    {
        path: 'Tracking',
        component: Tracking
    },
    {
        path: 'LabelPrint',
        component: LabelPrint
    },

  
   

]
